<template>
    <div class="box">
        <div class="v_header flexCenter" ref="getheight">
            <span class="headline">未知用户</span>
            <!-- <el-button class="input_button" size="mini" @click="getExport">导出</el-button> -->
        </div>
        <!-- <div class="flexCenter mb16" ref="getheight1"> -->
            <!-- <div class="flexCenter">
                <div
                    v-for="(item, index) of options"
                    @click="getStatus(item.value)"
                    :key="index"
                    class="u_status flexCenter"
                    :class="page.status == item.value ? 'active' : ''"
                >
                    <span class="label">{{ item.label }}</span>
                    <div v-if="message != [] && page.status == item.value" class="dot mr24">
                        {{ page.total > 99 ? '99+' : page.total }}
                    </div>
                    <div v-else class="mr24"></div>
                </div>
            </div> -->
            <!-- <el-input clearable @change="changeSearch_name" v-model="Search_name" placeholder="请输入医院名称或用户姓名"> </el-input> -->
        <!-- </div> -->
        <el-table :data="message" :max-height="height + 'px'" style="width: 100%">
            <el-table-column fixed label="提交时间" width="150" :render-header="renderPrice">
                <template slot-scope="scope">
                    {{ scope.row.created_on | formatOrdertime }}
                </template>
            </el-table-column>
            <el-table-column label="姓名/手机号" :render-header="renderPrice" width="180">
                <template slot-scope="scope">
                    <el-tooltip class="item" effect="dark" :content="scope.row.name + scope.row.phone_number" placement="bottom">
                        <div>
                            {{ scope.row.name }}
                            <div>{{ scope.row.phone_number }}</div>
                        </div>
                    </el-tooltip>
                </template>
            </el-table-column>
            <el-table-column label="所属医院" min-width="180" :render-header="renderPrice">
                <template slot-scope="scope">
                    <el-tooltip class="item" effect="dark" :content="scope.row.hospital_name" placement="bottom">
                        <span class="v_tips">{{ scope.row.hospital_name }} </span>
                    </el-tooltip>
                </template>
            </el-table-column>
            <el-table-column label="医院地址" min-width="180" :render-header="renderPrice">
                <template slot-scope="scope">
                    <el-tooltip
                        class="item"
                        effect="dark"
                        :content="
                            scope.row.province_info.name +
                            scope.row.city_info.name +
                            scope.row.district_info.name +
                            scope.row.hospital_position_detail
                        "
                        placement="bottom"
                    >
                        <span class="v_tips"
                            >{{ scope.row.province_info.name }} {{ scope.row.city_info.name }} {{ scope.row.district_info.name
                            }}{{ scope.row.hospital_position_detail }}</span
                        >
                    </el-tooltip>
                </template>
            </el-table-column>
            <el-table-column label="微信定位" min-width="180" :render-header="renderPrice">
                <template slot-scope="scope">
                    <el-tooltip
                        class="item"
                        effect="dark"
                        :content="
                            scope.row.wechat_province_name +
                            scope.row.wechat_city_name +
                            scope.row.wechat_district_name +
                            scope.row.wechat_position_detail
                        "
                        placement="bottom"
                    >
                        <span class="v_tips"
                            >{{ scope.row.wechat_province_name }} {{ scope.row.wechat_city_name }} {{ scope.row.wechat_district_name }}
                            {{ scope.row.wechat_position_detail }}
                        </span>
                    </el-tooltip>
                </template>
            </el-table-column>
            <el-table-column label="奖励码/产品" min-width="180" :render-header="renderPrice">
                <template slot-scope="scope">
                    <el-tooltip
                        class="item"
                        effect="dark"
                        :content="
                            scope.row.red_envelope_label + scope.row.product_info.product_name + scope.row.product_info.product_number
                        "
                        placement="bottom"
                    >
                        <span class="v_tips"
                            >{{ scope.row.red_envelope_label }} {{ scope.row.product_info.product_name }}&{{
                                scope.row.product_info.product_number
                            }}</span
                        >
                    </el-tooltip>
                </template>
            </el-table-column>
            <el-table-column label="状态" width="100">
                <template slot-scope="scope">
                    <el-tag :type="scope.row.status | client_user_status_type">{{ scope.row.status | client_user_status_list }}</el-tag>
                </template>
            </el-table-column>
            <el-table-column label="备注" min-width="150" >
                <template slot-scope="scope">
                    <el-tooltip class="item" effect="dark" :content="scope.row.remarks" placement="bottom">
                        <span class="v_tips">{{ scope.row.remarks }}</span>
                    </el-tooltip>
                </template>
            </el-table-column>
            <!-- <el-table-column label="操作" width="180" fixed="right">
                <template slot-scope="scope">
                    <div class="flexdown">
                        <div class="mb10" v-if="scope.row.status != 'passed' && scope.row.status != 'failed' && scope.row.status != 'ban'">
                            <el-button type="primary" size="mini" @click="getClick(scope, 'success')">通过</el-button>
                            <el-button type="info" size="mini" @click="getClick(scope, 'err')">拒绝</el-button>
                        </div>
                        <div>
                            <el-button type="primary" size="mini" @click="getClick(scope, 'edit')">编辑</el-button>
                            <el-button type="info" size="mini" @click="getClick(scope, 'remarks')">备注</el-button>
                        </div>
                        <el-button
                            class="mt10"
                            v-if="scope.row.status == 'passed' || scope.row.status == 'failed' || scope.row.status == 'ban'"
                            type="warning"
                            size="mini"
                            @click="getClick(scope, 'status')"
                            >调整用户分类</el-button
                        >
                    </div>
                </template>
            </el-table-column> -->
        </el-table>
      
        <!-- <div class="notificationn" v-if="notificationns">
            <div class="notificationn_left"></div>
            <div>
                <div class="notificationn_title" v-if="msg">{{ msg }}</div>
            </div>
        </div> -->
        <pagination :page="page" @getPage="getPage" @getNum="getNum"></pagination>
    </div>
</template>

<script>
import * as XLSX from 'xlsx';
export default {
    name: 'binding',
    data() {
        return {
            notificationns: false,
            msg: '',
            page: {
                num:10,
                page: 1,
                total: 0,
                has_name:'no',
                search_user_name: '',
                search_hospital_name: '',
                status: 'wait_audit'
            },
            options: [
                {
                    value: 'wait_audit',
                    label: '待审核'
                },
                {
                    value: 'passed',
                    label: '审核成功'
                },
                {
                    value: 'failed',
                    label: '审核失败'
                },
                {
                    value: 'ban',
                    label: '黑名单'
                }
            ],
            options1: [
                {
                    value: 'passed',
                    label: '审核成功'
                },
                {
                    value: 'failed',
                    label: '审核失败'
                },
                {
                    value: 'ban',
                    label: '黑名单'
                }
            ],
            area: [],
            array: [],
            value: [],
            regionParams: {
                lazy: true, //	是否动态加载子节点，需与 lazyLoad 方法结合使用
                lazyLoad: this.handleGetClassOrStudent //懒加载调用的方法
            },
            message: [],
            row: {
                province_info: {},
                city_info: {},
                district_info: {}
            },
            index: -1,
            type: '',
            resetDialogVisible: false,
            height: '',
            Search_name: '',
            children: []
        };
    },
    mounted() {
        window.screenHeight = document.body.clientHeight;
        this.screenHeight = window.screenHeight;
        this.height = this.screenHeight - this.$refs.getheight.offsetHeight  - 85 - 24 - 16 - 40;
        this.getMessage(); //获取列表
    },
    methods: {
        renderPrice(h, { column, $index }) {
            const styleFilter = {
                fontSize: '16px',
                fontWeight: 'bold',
                marginLeft: '8px'
            };
            return [
                column.label,
                h(
                    'i',
                    [
                        h('span', {
                            class: { 'el-icon-bottom': true },
                            style: {
                                ...styleFilter //设置样式
                            }
                        })
                    ] // 图标
                )
            ];
        },
      
        async getMessage() {
            let that = this;
            let obj = {
                page: that.page.page,
                num: that.page.num,
                has_name:'no',
                // search_hospital_name: that.page.search_hospital_name,
                // search_user_name: that.page.search_user_name,
                status: that.page.status
            };
            const res = await that.$get('/backapi/client_user', obj);
            console.log( res);
            
            if (res.count) {
                that.page.total = res.count
                that.message = res.data
              
            } else {
                that.page.total = 0;
                that.message = [];
            }
    
        },
        getPage(e) {
            this.page.page = e;
            this.getMessage();
        },
        getNum(e) {
            this.page.num = e;
            this.page.page = 1;
            this.getMessage();
        },
    
        
    }
};
</script>

<style lang="scss" scoped>
.test {
    font-family: 'PingFang SC';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 140%;
    /* or 22px */

    color: #21272a;
}
/deep/.el-form-item__content.el-select {
    width: 100%;
}
/deep/.el-textarea__inner {
    height: 193px !important;
    font-family: 'PingFang SC';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 140%;

    color: #697077;
    border: 1px solid #f2f4f8;
    filter: drop-shadow(0px 1px 1px #c1c7cd);
    margin-bottom: 16px;
}

.mt8 {
    margin-top: 8px;
}
/deep/.el-form-item__content {
    width: 100%;
}
/deep/.u_cascader {
    display: flex;
    flex-direction: column;
    align-items: baseline;
}
.v_buttons {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 129px;
    height: 48px;
    background: #91d9f2;
    border: 2px solid #91d9f2;
    border-radius: 8px;
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    letter-spacing: 0.5px;
    color: #ffffff;
}

/deep/ .v_dol .el-dialog {
    background: #ffffff;
    padding: 24px;
    border: 1px solid #dde1e6;
    border-radius: 16px;
}

/deep/.v_dol .el-dialog .el-dialog__header {
    padding: 0;
    margin-bottom: 24px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}
/deep/.v_dol .el-dialog__headerbtn {
    position: relative;
    top: 0;
    right: 0;
}
/deep/.v_dol .el-dialog__close {
    font-size: 18px;
    color: #21272a;
}
/deep/.v_dol .el-dialog__title {
    color: #21272a;
    font-family: 'PingFang SC';
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
}
/deep/.v_dol .el-dialog__body {
    padding: 0;
}
/deep/.v_dol .el-input__inner {
    height: 48px;
    padding: 12px 16px;
    border: 1px solid #f2f4f8;
    filter: drop-shadow(0px 1px 1px #c1c7cd);
    border-radius: 8px;
    font-weight: 400;
    font-size: 16px;
    color: #697077;
}

/deep/.flexCenter .el-input {
    width: 387px;
}
/deep/ el-input::-webkit-input-placeholder {
    font-family: 'PingFang SC';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    letter-spacing: 0.5px;
    color: #ababab;
}
/deep/.flexCenter .el-input .el-input__inner {
    background: #ffffff;
    border: 1px solid #16307c;
    border-radius: 4px;
    font-weight: 400;
    font-size: 16px;
    color: #121619;
    width: 100%;
    height: 35px;
    background: url('../../assets/img/search-outline.png') no-repeat 8px center;
    background-size: 24px;
    padding-left: 40px;
}
.mb16 {
    margin-bottom: 16px;
    justify-content: space-between;
}
.dot {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 18px;
    background: #16307c;
    border-radius: 9px;
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 140%;
    /* identical to box height, or 17px */

    text-align: center;

    /* Default/White */

    color: #ffffff;
    margin-left: 4px;
}
.mr24 {
    margin-right: 24px;
}
.u_status {
    font-family: 'PingFang SC';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 100%;
    letter-spacing: 0.5px;
    color: #21272a;
    cursor: pointer;
}
.active {
    color: #001d6c !important;
}
.v_header {
    justify-content: space-between;
    margin-bottom: 24px;
}
/deep/.el-table .el-table__cell {
    border: none;
}
/deep/.el-table thead {
    font-family: 'PingFang SC';
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: #121619;
}
/deep/.el-table {
    font-weight: 400;
    font-size: 12px;
    color: #121619;
}

.flexdown {
    display: flex;
    flex-direction: column;
    align-items: center;
}
.mb10 {
    margin-bottom: 10px;
}
.mt10 {
    margin-top: 10px;
}
</style>
